import { makeStyles, tokens } from "@fluentui/react-components";
export const useSensitivityButtonMenuStyles = makeStyles({
    sensitivityMenuList: {
        rowGap: tokens.spacingVerticalNone
    },
    menuDivider: {
        margin: tokens.spacingVerticalNone
    },
    menuItemLabel: {
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    },
    menuItemIcon: {
        minWidth: tokens.spacingHorizontalXL
    },
    tooltipContainer: {
        borderRadius: tokens.borderRadiusXLarge,
        boxShadow: tokens.shadow16
    },
    menuPopover: {
        width: "248px !important"
    },
    menuItemNoDefaultCheckmark: {
        display: "none",
        margin: `${tokens.spacingVerticalNone} ${tokens.spacingHorizontalNone}`
    }
});
/**
 * Positioning configuration for sensitivity menu popover
 */ export const sensitivityMenuPositioning = {
    offset: {
        mainAxis: 2
    }
};
